import Vue from "vue";
//Plugins
import BountixpFormFramework from 'bountixp-form-framework'
import VuetifyPhoneField from 'vuetify-phone-field'
import Router from "vue-router"
import { routes } from "./routes"
import vuetify from "./plugins/vuetify"
import VueScrollTo from "vue-scrollto"

import App from "./App.vue"
import { formBus } from "./formBus"

import { VSelect, VTextField } from 'vuetify/lib'
Vue.use(VuetifyPhoneField, {
  VSelect,
  VTextField
})

Vue.use(BountixpFormFramework, {formBus})
Vue.use(Router)
const router = new Router({
  routes,
  base: "/trial",
  mode: "history"
})
Vue.use(VueScrollTo)

new Vue({
  el: "#bountixp_trial_form_1",
  router,
  vuetify,
  render: h => h(App)
})
